<template>
  <div>
    <PageAllow controller="StockDetails" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <!-- 入库日期 / 时间类型 -->
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- TODO:导出 按钮 -->

              <v-btn
                v-if="$permission.permissionAllow('StockDetails', 'export')"
                small
                color="print"
                dark
                class="ms-1"
                @click="exportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("StockDetails.Export.excel") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 批次号 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="stock_batch_code"
                    v-model="options.stock_batch_code"
                    @text="orderCodeKeyword = $event"
                    :label="$t('StockDetails.Fields.stock_batch_code')"
                  />
                </v-col>
                <!-- 入库单号 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="stock_in_order_code"
                    v-model="options.stock_in_order_code"
                    @text="stockInOrderCodeKeyword = $event"
                    :label="$t('StockDetails.Fields.stock_in_order_code')"
                  />
                </v-col>
                <!-- 商品分类 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterialCategory
                    v-model="materialCategorySelected"
                  />
                </v-col>
                <!-- 商品 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterial
                    v-model="materialSelected"
                    :material-categories="
                      materialCategorySelected ? [materialCategorySelected] : []
                    "
                  />
                </v-col>
                <!-- 仓库组别 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStockDistrict v-model="stockDistrictSelected" />
                </v-col>
                <!-- 仓库中心 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStocks
                    v-model="stocksSelected"
                    :stock-district="stockDistrictSelected"
                    :stock-types="[0]"
                  />
                </v-col>
                <!-- 状态 -->
                <v-col cols="12" sm="6" md="4">
                  <!-- 过期 -->
                  <SearcherExpiredStatus
                    :items="$consts.expiredFlgs"
                    v-model="options.expired_flgs"
                  />
                </v-col>
                <v-spacer />
                <v-col cols="12" sm="6" md="4">
                  <!-- 冻结 -->
                  <SearcherStatus
                    :label="$t('StockDetails.prohibit_flg.ObjectName')"
                    :items="$consts.prohibitFlgs"
                    v-model="options.prohibit_flgs"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <!-- 使用 -->
                  <SearcherStatus
                    :items="$consts.use.use_status"
                    v-model="options.status"
                    :label="$t('StockDetails.use_status.ObjectName')"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="stock_detail"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:body.prepend>
              <tr class="d-none d-sm-table-row">
                <td>
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <td colspan="5"></td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>{{ stock_first_total | formatTwoDot }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span> {{ stock_current_total | formatTwoDot }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money")
                    }}{{ price_total | formatMoney }}</span
                  >
                </td>
                <td></td>
                <td></td>
                <td v-if="settings && settings.product_date_setting"></td>
                <td v-if="settings && settings.product_date_setting"></td>
                <td></td>
              </tr>
              <!-- 小屏幕 -->
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("TableSum") }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("StockDetails.Fields.stock_first") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ stock_first_total | formatTwoDot }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("StockDetails.Fields.stock_current") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money")
                    }}{{ stock_current_total | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("StockDetails.Fields.count_num") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}{{ price_total | formatMoney }}
                  </div>
                </td>
              </tr>
            </template>

            <template v-slot:header.actions="{ header }">
              <span class="ml-3">
                {{ header.text }}
                <v-icon x-small>fa-sliders-h</v-icon>
              </span>
            </template>
            <template v-slot:item.material.material_code="{ item }">
              {{ item.material.material_code }}
            </template>
            <template v-slot:item.material.material_name="{ item }">
              {{ item.material.material_name }}
              <br />
              <span class="caption secondary--text">
                  {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                  <span v-if="item.material && item.material.standard_name && item.material.standard_name.length > 12" :title="item.material.standard_name" style="cursor: pointer">
                    {{ item.material.standard_name.slice(0, 12) + "......" }}
                  </span>
                  <span v-else>
                    {{ item.material.standard_name }}
                  </span>
                </span>
            </template>
            <!-- 状态文字/颜色 -->
            <!-- 冻结状态 -->
            <template v-slot:item.prohibit_flg="{ item, index }">
              <span :v-resize="!index ? $stickTableResizer() : null"> </span>
              <v-chip
                small
                label
                :color="item.prohibit_flg | prohibitFlgsColor"
                :text-color="item.prohibit_flg | prohibitFlgsTextColor"
              >
                {{ item.prohibit_flg | prohibitFlgsText }}
              </v-chip>
            </template>
            <!-- 过期状态 expired_flg-->
            <template v-slot:item.expired_flg="{ item }">
              <v-chip
                small
                label
                :color="item.expired_flg | expiredFlgsColor"
                :text-color="item.expired_flg | expiredFlgsTextColor"
              >
                {{ item.expired_flg | expiredFlgsText }}
              </v-chip>
            </template>
            <!-- 入库量格式化 -->
            <template v-slot:item.stock_first="{ item }">
              {{ item.stock_first | formatTwoDot }}
            </template>
            <!-- 当前库存格式化 -->
            <template v-slot:item.stock_current="{ item }">
              {{ item.stock_current | formatTwoDot }}
            </template>
            <!-- 格式化金额 -->
            <template v-slot:item.price="{ item }">
              {{ $t("Global.money") }}{{ item.price | formatMoney }}
            </template>
            <!-- 小计 -->
            <template v-slot:item.count_num="{ item }">
              {{ $t("Global.money")
              }}{{ (item.price * item.stock_current) | formatMoney }}
            </template>
            <!-- 生产日期 -->
            <template v-slot:item.production_date="{ item }">
              <span>{{ item.production_date | formatDate }}</span>
            </template>
            <!-- 过期日期 -->
            <template v-slot:item.expired_date="{ item }">
              <span>{{ item.expired_date | formatDate }}</span>
            </template>
            <!-- 操作 -->
            <template v-slot:item.actions="{ item }">
              <StockDetailsActions
                :stock_detail="item"
                showView
                showProhibit
                showUnProhibit
                showLoss
                @done="getStockDetailsFromAPI"
                class="ml-3"
              />
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import StockDetails from "@/api/stock_details";
import SearcherMaterialCategory from "@/components/plugins/SearcherMaterialCategory";
import SearcherStockDistrict from "@/components/plugins/SearcherStockDistrict";
import SearcherStocks from "@/components/plugins/SearcherStocks";
import SearcherMaterial from "@/components/plugins/SearcherMaterial";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherExpiredStatus from "@/components/plugins/SearcherExpiredStatus";
import StockDetailsActions from "./plugins/Actions";

const defaultOptions = {
  datetimeRadioSelected: "in",
  in_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  in_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  expired_time_from: "",
  expired_time_to: "",
  production_time_from: "",
  production_time_to: "",
  material_ids: [],
  category_ids: [],
  stock_batch_code: "",
  status: [0, 2],
  prohibit_flgs: [0, 1],
  expired_flgs: [0, 1],
  stock_in_order_code: "",
};

export default {
  name: "stockDetails",

  data: () => ({
    stock_detail: [],
    orderCodeKeyword: "",
    materialCategorySelected: null,
    materialSelected: null,
    stockDistrictSelected: null,
    stocksSelected: [],
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem("stock_detail-options")
        ? sessionStorage.getItem("stock_detail-options")
        : JSON.stringify(defaultOptions)
    ),
    stock_first_total: 0,
    stock_current_total: 0,
    price_total: 0,
    stockInOrderCodeKeyword: "",
  }),

  components: {
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    PageAllow,
    SearcherMaterialCategory,
    SearcherStockDistrict,
    SearcherStocks,
    SearcherMaterial,
    SearcherKeyword,
    SearcherStatus,
    SearcherExpiredStatus,
    StockDetailsActions,
  },
  props: {
    detailMode: Boolean,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.stockDetails"),
        disabled: true,
        href: "/stock-details",
      },
    ],
    datetimeRadios: () => [
      {
        key: "in",
        text: i18n.t("StockDetails.Fields.created_date"),
      },
      {
        key: "production",
        text: i18n.t("StockDetails.Fields.production_date"),
      },
      {
        key: "expired",
        text: i18n.t("StockDetails.Fields.expired_date"),
      },
    ],
    headers() {
      var headers = [
        {
          text: i18n.t("StockDetails.Fields.stock_batch_code"),
          align: "start",
          sortable: false,
          value: "stock_batch_code",
        },
        {
          text: i18n.t("StockDetails.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material.material_code",
        },
        {
          text: i18n.t("StockDetails.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "material.material_name",
        },
        {
          text: i18n.t("StockDetails.Fields.material_category"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "material.material_category.name",
        },
        {
          text: i18n.t("StockDetails.Fields.unit"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "unit",
        },
        {
          text: i18n.t("StockDetails.Fields.price"),
          align: "end",
          sortable: false,
          value: "price",
        },
        // 入库量
        {
          text: i18n.t("StockDetails.Fields.stock_first"),
          align: "end",
          sortable: false,
          value: "stock_first",
        },
        // 当前库存
        {
          text: i18n.t("StockDetails.Fields.stock_current"),
          align: "end",
          sortable: false,
          value: "stock_current",
        },
        // 小计
        {
          text: i18n.t("StockDetails.Fields.count_num"),
          align: "end",
          sortable: false,
          value: "count_num",
        },
        // 过期状态
        {
          text: i18n.t("StockDetails.Fields.expired_status"),
          align: "start",
          sortable: false,
          value: "expired_flg",
        },
        // 冻结状态
        {
          text: i18n.t("StockDetails.Fields.prohibit_flg"),
          align: "start",
          sortable: false,
          value: "prohibit_flg",
        },
      ];
      if (this.settings && this.settings.product_date_setting) {
        headers.push(
          {
            text: i18n.t("StockDetails.Fields.production_date"),
            align: "center",
            value: "production_date",
            width: 136,
          },
          {
            text: i18n.t("StockDetails.Fields.expired_date"),
            align: "center",
            value: "expired_date",
            width: 136,
          }
        );
      }
      headers.push(
        // 操作
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        }
      );
      return headers;
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "stickTableCols"]),
  },

  mounted() {
    this.$commonUtils
      .loadOptions("stock_detail", [
        "materialCategorySelected",
        "stockDistrictSelected",
        "stocksSelected",
        "materialSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "stockDistrictSelected":
                this.stockDistrictSelected = selected.value;
                break;
              case "stocksSelected":
                this.stocksSelected = selected.value;
                break;
              case "materialCategorySelected":
                this.materialCategorySelected = selected.value;
                break;
              case "materialSelected":
                this.materialSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options, {
        stock_batch_code: this.orderCodeKeyword,
        stock_in_order_code: this.stockInOrderCodeKeyword,
      });
    },
    resetSearch() {
      this.stocksSelected = [];

      this.stockDistrictSelected = null;
      this.materialCategorySelected = null;
      this.materialSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.stock_batch_code, this.$refs.stock_in_order_code].forEach(
        (k) => {
          if (k) k.clear();
        }
      );
    },
    getStockDetailsFromAPI() {
      this.id = this.$route.query.stock_id;
      StockDetails.fetch(
        Object.assign({ stock_types: [0] }, this.options) //默认只查询真实仓库的批次
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_detail = response.data.stock_details;
            this.stock_first_total = response.data.stock_first_total;
            this.stock_current_total = response.data.stock_current_total;
            this.price_total = response.data.price_total;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    exportExcel() {
      StockDetails.exports(this.options);
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getStockDetailsFromAPI();
        sessionStorage.setItem(
          "stock_detail-options",
          JSON.stringify(this.options)
        );
      },
    },

    // 仓库组别
    stockDistrictSelected: {
      handler() {
        this.options.stock_district_ids = this.stockDistrictSelected
          ? [this.stockDistrictSelected.id]
          : [];
        sessionStorage.setItem(
          "stock_detail-stockDistrictSelected",
          JSON.stringify(this.stockDistrictSelected)
        );
      },
    },
    // 仓配中心搜索
    stocksSelected: {
      handler() {
        this.options.stock_ids = this.stocksSelected
          ? this.stocksSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "stock_details-stocksSelected",
          JSON.stringify(this.stocksSelected)
        );
      },
    },
    // 商品分类
    materialCategorySelected: {
      handler() {
        this.options.category_ids = this.materialCategorySelected
          ? [this.materialCategorySelected.id]
          : [];
        sessionStorage.setItem(
          "stock_detail-materialCategorySelected",
          JSON.stringify(this.materialCategorySelected)
        );
      },
    },

    // 商品
    materialSelected: {
      handler() {
        this.options.material_ids = this.materialSelected
          ? [this.materialSelected.id]
          : [];
        sessionStorage.setItem(
          "stock_detail-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },
  },
};
</script>

<style>
</style>